import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion'; // Static import
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { HeaderComponent } from './components/header/header.component';

import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router'; // Static import
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { TopDestinationComponent } from '../components/home/top-destination/top-destination.component';
import { CalenderMobileViewComponent } from './components/flight-search-box/calender-mobile-view/calender-mobile-view.component';
import { FlightSearchBoxComponent } from './components/flight-search-box/flight-search-box.component';
import { MobileInputComponent } from './components/flight-search-box/mobile-input/mobile-input.component';
import { MultiCityComponent } from './components/flight-search-box/multi-city/multi-city.component';
import { OneWayComponent } from './components/flight-search-box/one-way/one-way.component';
import { RoundTripComponent } from './components/flight-search-box/round-trip/round-trip.component';
import { FooterComponent } from './components/footer/footer.component';
import { SkeletonAirportListComponent } from './components/skeleton-airport-list/skeleton-airport-list.component';
import { FilterCityPipe } from './pipes/filter-city.pipe';
import { HighlighterPipe } from './pipes/highlighter.pipe';
import { LimitToPipe } from './pipes/limit-to.pipe';

const Material = [
  MatButtonModule,
  MatExpansionModule, // Static import
  MatMenuModule,
  MatIconModule,
  MatTabsModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatRadioModule,
  MatAutocompleteModule,
  MatOptionModule,
  MatProgressSpinnerModule,
];

const Components = [
  HeaderComponent,
  FlightSearchBoxComponent,
  OneWayComponent,
  MultiCityComponent,
  RoundTripComponent,
  CalenderMobileViewComponent,
  TopDestinationComponent,
  FooterComponent,
];

@NgModule({
  declarations: [
    Components,
    HighlighterPipe,
    FilterCityPipe,
    LimitToPipe,
    MobileInputComponent,
    SkeletonAirportListComponent,
  ],
  imports: [
    CommonModule,
    ...Material, // Spread operator to include all Material modules
    ReactiveFormsModule,
    TranslateModule,
    NgbDatepickerModule,
    RouterModule, // Static import
  ],
  providers: [],
  exports: [HeaderComponent, ...Material, Components, TranslateModule],
})
export class SharedModule {}
